.selectBtn {
  composes: primaryBtn from '../utils.module.css';
  margin-top: 0.5em;
  margin-bottom: 0.5rem;
  font-size: 1.125em;
}

.hint {
  composes: hint from '../utils.module.css';
  max-width: 40em;
}
